export enum ReportReason {
  SPAM = 'spam',
  FALSE_INFO = 'false_info',
  OFFENSIVE = 'offensive',
}
